export const themes = {
  default: {
    thItemIcon: 'flex items-center justify-center h-full text-black',
    thItemIconSize: '75%',
    thItemLabel: 'font-bold inline-flex gap-5 items-center mt-10 text-14 text-black',
  },
};
